export class UpdateImageInfoDetailModel {
  public ImageID: string = <string>'';                // 画像ID
  public ImageType: string = <string>'';				// 画像種別
  public ProcessInstruct: string = <string>'';	    // 調理指示
  public CookingExPublish: string = <string>'';		// 調理例掲載区分
  public CookingDiv: string = <string>'';				// 料理分類
  public CookingName: string = <string>'';			// 料理名
  public MaterialName: string = <string>'';			// 材料名
  public EventID: string = <string>'';				// 季節・催事
  public PhotoContentsDiv: string = <string>'';		// 撮影内容区分
  public Remarks: string = <string>'';				// 備考
  public KeyWord: string = <string>'';				// キーワード
  public TextCaption: string = <string>'';			// 画像キャプション
  public PhotoInstructContents: string = <string>'';	// 掲載指示内容
  public MultipleCode: string = <string>'';	// 複数コード
  public SampleNum: string = <string>'';	// サンプル数量
  public PromotionFlg: string = <string>'';	// プロモーション
  public Shooting: string = <string>'';	// 包材_撮影
  public ShootingPackageText: string = <string>'';	// 包材_撮影／外包材と個包装
  public ShootingAngle: string = <string>'';	// 包材_撮影角度
  public Alignment: string = <string>'';	// 包材_並べ方
  public AlignmentHorizontal: string = <string>'';	// 包材_並べ方／横
  public AlignmentVertical: string = <string>'';	// 包材_並べ方／縦
  public VesselPlating: string = <string>'';	// 皿盛・ザル盛_器
  public ColorChange: string = <string>'';  // 皿の色変更（基本はグリーン）
  public Plating: string = <string>'';	// 皿盛・ザル盛_盛り方
  public Accompaniments: string = <string>'';	// 皿盛・ザル盛_添え物
  public QtyCookNecessary: string = <string>'';	// 調理要_数量
  public QtyCookNecessaryNum: string = <string>'';	// 調理要_数量／個数
  public QtyCookNecessaryVesselNum: string = <string>'';	// 調理要_数量／器数
  public VesselShapeCookNecessary: string = <string>'';	// 調理要_器形状
  public VesselCookNecessary: string = <string>'';	// 調理要_器
  public PhotoImageCookNecessary: string = <string>'';	// 調理要_イメージ
  public CrossSection: string = <string>'';	// 断面
  public PhotoRenditionCookNecessary: string = <string>'';	// 調理要_撮影演出
  public QtyCookUnnecessary: string = <string>'';	// 調理不要_数量
  public QtyCookUnnecessaryNum: string = <string>'';	// 調理不要_数量／個数
  public QtyCookUnnecessaryVesselNum: string = <string>'';	// 調理不要_数量／器数
  public VesselShapeCookUnnecessary: string = <string>'';	// 調理不要_器形状
  public VesselCookUnnecessary: string = <string>'';	// 調理不要_器
  public PhotoImageCookUnnecessary: string = <string>'';	// 調理不要_イメージ
  public PhotoRenditionCookUnnecessary: string = <string>'';	// 調理不要_撮影演出
  public CropExistenceType: string = <string>'';	// 切抜or角版
  public ReferenceImageFileName1: string = <string>'';  // 参照資料ファイル名1
  public PhotoInstructContents1: string = <string>'';   // 撮影指示内容1
  public ReferenceImageFileName2: string = <string>'';  // 参照資料ファイル名2
  public PhotoInstructContents2: string = <string>'';   // 撮影指示内容2
  public ReferenceImageFileName3: string = <string>'';  // 参照資料ファイル名3
  public PhotoInstructContents3: string = <string>'';   // 撮影指示内容3
}